'use client';
import React from 'react';
import Container from '@/components/ui/Container';
import HeroSectionHeading from '@/components/ui/HeroSectionHeading';
import { privacyPolicyData } from '../utils/page-data/privacyPolicy';

const PrivacyPolicy = () => {
  return (
    <>
      <div
        style={{
          backgroundImage:
            'radial-gradient(154.86% 76.83% at 50% 22.26%,rgb(247 247 248/.4) 8.98%,#F7F7F8 45.99%)',
        }}
        className="-mt-20"
      >
        <div className="bg-aboutUsHeroBg bg-full bg-center bg-no-repeat">
          <div className="flex h-full items-center justify-center">
            <Container className="relative h-full pb-14 pt-[150px] lg:pb-[100px]">
              <div className="flex w-full items-center justify-center">
                <HeroSectionHeading
                  heading={privacyPolicyData?.title}
                  description={privacyPolicyData?.description}
                  className="mx-auto items-center"
                  descriptionStyle="text-center text-xl"
                />
              </div>
            </Container>
          </div>
        </div>
      </div>
      <Container className="max-w-[920px] py-12 md:py-16 lg:py-20 4xl:py-[100px]">
        <>
          <div className="space-y-6">
            {/* Information Paragraphs */}
            {privacyPolicyData.information &&
              privacyPolicyData.information.map((info, i) => (
                <p
                  key={i}
                  className="font-opt text-xl font-normal leading-7 text-optDesc"
                >
                  {info}
                </p>
              ))}

            {/* All Sections (inside the same DIV) */}
            {privacyPolicyData.informationList &&
              privacyPolicyData.informationList.map((section, index) => (
                <div key={index} className="space-y-4">
                  {/* Heading */}
                  {section.heading && (
                    <h2 className="font-opt text-2xl font-medium leading-7 text-primary">
                      {section.heading}
                    </h2>
                  )}

                  {/* description array */}
                  {section.description && (
                    <p className="font-opt text-xl font-normal leading-7 text-optDesc">
                      {section.description}
                    </p>
                  )}

                  {/* itemList */}
                  {section?.itemList && (
                    <ul className="ml-4 list-disc space-y-1">
                      {section.itemList.map((item, i) => (
                        <li
                          key={i}
                          className="font-opt text-xl font-normal leading-7 text-optDesc"
                          dangerouslySetInnerHTML={{ __html: item }}
                        />
                      ))}
                    </ul>
                  )}

                  {/* Nested list */}
                  {section.list &&
                    section.list.map((sub, i) => (
                      <div key={i} className="space-y-2">
                        {sub.heading && (
                          <h3 className="font-opt text-2xl font-medium leading-7 text-primary">
                            {sub.heading}
                          </h3>
                        )}

                        {sub.description && (
                          <p className="font-opt text-xl font-normal leading-7 text-optDesc">
                            {sub.description}
                          </p>
                        )}

                        {sub.itemList && (
                          <ul className="ml-4 list-disc space-y-1">
                            {sub.itemList.map((subItem, j) => (
                              <li
                                key={j}
                                className="font-opt text-xl font-normal leading-7 text-optDesc"
                              >
                                {subItem}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    ))}
                  {/* descriptionList */}
                  {section.descriptionList &&
                    section.descriptionList.map((desc, i) => (
                      <p
                        key={i}
                        className="font-opt text-xl font-normal leading-7 text-optDesc"
                      >
                        {desc}
                      </p>
                    ))}
                  {/* description1 */}
                  {section.description1 && (
                    <p className="font-opt text-xl font-normal leading-7 text-optDesc">
                      {section.description1}
                    </p>
                  )}
                </div>
              ))}
          </div>
        </>
      </Container>
    </>
  );
};

export default PrivacyPolicy;
